import { j as e } from "../../../jsx-runtime-CQ7OqOhn.js";
import { faSpinnerThird as a } from "@fortawesome/pro-duotone-svg-icons";
import { loaderStyles as m } from "./Loader.styles.js";
import i from "../Icon/Icon.js";
import n from "../../../tailwindConfig/bclTwMerge.js";
const x = (r) => {
  const { color: o = "primary", className: s } = r, { base: t } = m;
  return /* @__PURE__ */ e.jsx(
    i,
    {
      className: n(t, s),
      icon: a,
      color: o,
      "data-testid": "loading-spinner"
    }
  );
};
export {
  x as default
};
